// Optional lecture time range for attendance registers. The server stores
// "HH:MM" (24h) text in start_time / end_time and requires both or neither,
// end after start; <input type="time"> already yields that format, so these
// helpers only validate (same rule as the server) and format for display.

/** "09:00" -> "9:00 AM"; anything unparseable -> "". */
function clock12(hhmm?: string | null): string {
    const m = /^(\d{1,2}):(\d{2})/.exec((hhmm || "").trim())
    if (!m) return ""
    const h = Number(m[1])
    const min = m[2]
    if (h > 23 || Number(min) > 59) return ""
    return `${h % 12 === 0 ? 12 : h % 12}:${min} ${h < 12 ? "AM" : "PM"}`
}

/** "9:00 AM – 11:00 AM", or "" when the lecture has no time range. */
export function formatLectureTime(start?: string | null, end?: string | null): string {
    const s = clock12(start)
    const e = clock12(end)
    return s && e ? `${s} – ${e}` : ""
}

/** null when the pair is acceptable (both empty, or a valid ordered range). */
export function lectureTimeError(start: string, end: string): string | null {
    if (!start && !end) return null
    if (!start || !end) return "Set both start and end time, or clear them."
    if (end <= start) return "End time must be after start time." // "HH:MM" compares correctly as text
    return null
}
